import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CopyFilledSvg from "@ant-design/icons-svg/es/asn/CopyFilled";
import AntdIcon from "../components/AntdIcon";
var CopyFilled = function CopyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CopyFilled.displayName = 'CopyFilled';
}
export default /*#__PURE__*/React.forwardRef(CopyFilled);